export class EnvironmentSettings {
    public static API_ICON_REPOSITORY = "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com/icon/";
}
